export const environment = {
  production: true,
  env: 'dev',
  authLoginUrl: 'https://idm.dev.zsservices.com/Alnylam/IdentityManager/app/Web/MyAccount.aspx',
  authLogOutUrl: 'https://idm.dev.zsservices.com/Alnylam/IdentityManager/app/Web/logout.aspx',
  staticJSON: false,
  forceServeStaticDataFor: [],
};

